// Zeit-Umrechnung für den Kapitel-Editor des CMS: Timecode ⇄ Millisekunden.
//
// ⚠️ Die Datei hiess einmal nach ihrem grössten Teil, dem Markers.csv-Parser. Der ist am
// 2026-09-08 entfallen (Tom-Entscheid „1 bis 7 wie empfohlen", Punkt 7: das CMS importiert keine
// Markers.csv mehr, der Ingest liest sie selbst aus dem Master). Der Name bleibt, damit die
// Importpfade nicht ohne Not wandern.
//
// ⛔ Was hier steht, gehoert NICHT zur CSV und ist ausdruecklich geblieben — der Posten nannte
// „`markersParser.ts` entfernen", und das haette drei Stellen gebrochen:
//   • `parseTimecodeToMs` — `MindBookForm`, beim Speichern: getippte Zeit → Millisekunden.
//   • `formatMsToTimecode` — `MindBookForm` (Kapitelzeilen) UND `FassungsUebersicht` (3×).
// Gemessen Export fuer Export, nicht ueberschlagen.

// "[H:]M:SS(.mmm)" oder reine Sekunden → Millisekunden. null bei Unparsebarem.
export function parseTimecodeToMs(raw: string): number | null {
  const s = (raw ?? '').trim();
  if (!s) return null;
  const parts = s.split(':');
  if (parts.length === 0 || parts.length > 3) return null;
  const nums = parts.map((p) => Number(p.replace(',', '.')));
  if (nums.some((n) => !Number.isFinite(n) || n < 0)) return null;
  let seconds: number;
  if (parts.length === 1) seconds = nums[0]!;
  else if (parts.length === 2) seconds = nums[0]! * 60 + nums[1]!;
  else seconds = nums[0]! * 3600 + nums[1]! * 60 + nums[2]!;
  return Math.round(seconds * 1000);
}

// ms → "m:ss" bzw. "h:mm:ss" (Anzeige im Kapitel-Editor).
export function formatMsToTimecode(ms: number): string {
  const total = Math.max(0, Math.floor((ms || 0) / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}
